import React from 'react'
import cn from 'classnames'

import Button from 'app/components/ButtonDefault'
import PlusSVG, { Props } from 'app/components/SVGS/Plus'
import { EmptyBlockProps } from './EmptyBlock.interface'
import { EColors } from 'app/constants/colors'

import './styles.scss'

const bc = 'empty-block'

const iconProps: Props = {
  svgProps: {
    width: '47px',
    height: '47px',
  },
  pathProps: {
    fill: EColors.BLUE,
  },
}

const EmptyBlock: React.FC<EmptyBlockProps> = ({
  onAdd,
  btnText,
  className,
  children,
  stretch,
  isShowSubmitButton,
  handleSubmit,
  isDisabledBtnText,
  submitBtnText,
  isShowActionButtons = true,
  t,
  tReady, // don't put inside html elements
  ...rest
}) => {
  return (
    <div
      className={cn(bc, className, {
        [`${bc}__stretch`]: stretch,
      })}
      {...rest}
    >
      <>
        {children ||
          (isShowActionButtons && (
            <>
              <Button onClick={() => onAdd && onAdd()} className={`${bc}__button`} icon={<PlusSVG {...iconProps} />}>
                {t(btnText as string)}
              </Button>
              {isShowSubmitButton && (
                <Button
                  primary
                  onClick={() => handleSubmit && handleSubmit()}
                  disabled={isDisabledBtnText}
                  icon={<PlusSVG {...iconProps} />}
                >
                  {t(submitBtnText as string)}
                </Button>
              )}
            </>
          ))}
      </>
    </div>
  )
}

export default EmptyBlock
